import React from "react"
import ImgServices from "../../images/services-hero.svg"

const Hero = () => {
  return (
    <section className="container mx-auto pt-8 lg:pt-24 px-6">
      <div className="flex flex-col-reverse md:flex-row md:items-center">
        <div className="w-full md:w-1/2 text-4xl leading-tight">
          <h1 className="lg:text-7xl font-light pb-8">
            <span className="text-secondary font-bold">Our distinctive</span> characteristics
          </h1>
          <h2 className="lg:text-6xl font-light pb-8">
            <b>More than </b>
            <span className="text-secondary font-bold">10 years</span> of experience
          </h2>
          <h2 className="lg:text-6xl pb-8">
            <b><span className="text-secondary">+ 100 </span> Avalithers </b> around the world
          </h2>
        </div>
        <div className="w-full md:w-1/2">
          <img src={ImgServices} alt="Our distinctive characteristics" />
        </div>
      </div>
    </section>
  )
}

export default Hero
